import { useRouter } from 'next/navigation';
import { useAuth } from './useAuth';
import { useEffect } from 'react';
import { signOut } from 'next-auth/react';

export function useSignOut() {
  const { isLoggedIn } = useAuth();
  const router = useRouter();

  useEffect(() => {
    if (isLoggedIn) {
      signOut({ callbackUrl: '/' })
        .catch((err) => {
          console.error('Sign out error', err);
        })
        .then(() => {
          console.log('Sign out success');
        });
    } else {
      router.push('/');
      return;
    }
  }, [isLoggedIn, router]);
}
